import graphql from "babel-plugin-relay/macro";
import { PaymentRowWarningIcon } from "components/payment/PaymentRowWarningIcon";
import { Message } from "shared/components/Message";
import { animalMessages } from "domain/animal/animalMessages";
import { paymentMessages } from "domain/payment/paymentMessages";
import { PaymentRowLicenceDetails_configuration } from "generatedQueries/PaymentRowLicenceDetails_configuration.graphql";
import { PaymentRowLicenceDetails_paymentRow } from "generatedQueries/PaymentRowLicenceDetails_paymentRow.graphql";
import React, { FC } from "react";
import { MessageDescriptor, useIntl } from "react-intl";
import { createFragmentContainer } from "react-relay";

interface IGraphQlProps {
    configuration: PaymentRowLicenceDetails_configuration;
    paymentRow: PaymentRowLicenceDetails_paymentRow;
}

const InternalPaymentRowLicenceDetails: FC<IGraphQlProps> = ({
    configuration,
    paymentRow,
}) => {
    const intl = useIntl();

    if (paymentRow.isRenewal && paymentRow.isLateFee) {
        return <Message message={paymentMessages.lateFeeMessage} />;
    }

    const hasWarning = paymentRow.blocked || !paymentRow.rabiesIsValid;

    let title: MessageDescriptor | undefined;

    if (paymentRow.blocked) {
        title = paymentMessages.animalBlockedTooltip;
    } else if (!paymentRow.rabiesIsValid) {
        title = animalMessages.rabiesExpiryInvalidTooltip;
    }

    const warningHeading = paymentRow.blocked ? paymentMessages.animalBlockedHeading : animalMessages.rabiesExpiryInvalidHeading;
    const warningMessage = paymentRow.blocked ? paymentMessages.animalBlockedError : animalMessages.rabiesExpiryInvalidError;

    return (
        <div title={title && intl.formatMessage(title)}>
            {paymentRow.licenceType}
            {
                paymentRow.isRenewal &&
                <>{" "}<strong><Message message={paymentMessages.renewalMessage} /></strong></>
            }
            {
                hasWarning &&
                <PaymentRowWarningIcon
                    id={paymentRow.animalId}
                    colour={paymentRow.blocked ? "danger" : "warning"}
                    ariaLabel={`${intl.formatMessage(warningHeading)} ${intl.formatMessage(warningMessage, { OrganisationContact: configuration.organisationContact })}`}
                    heading={warningHeading}
                    message={warningMessage}
                    values={{ OrganisationContact: configuration.organisationContact }}
                />
            }
        </div>
    );
};

export const PaymentRowLicenceDetails = createFragmentContainer(InternalPaymentRowLicenceDetails, {
    configuration: graphql`
        fragment PaymentRowLicenceDetails_configuration on Configuration {
            organisationContact
        }`,
    paymentRow: graphql`
        fragment PaymentRowLicenceDetails_paymentRow on LicensingPaymentFormRow {
            rabiesIsValid
            blocked
            animalId
            licenceType
            isRenewal
            isLateFee
        }`,
});
